import { addScript } from '@/utils/browser'

// One self-contained file; a new version goes into a new folder.
const AUTOPILOT_VIEWER = '/vendor/autopilot-viewer/0.2.1/autopilot-viewer.js'

const options = {
  language: 'ru'
}

let script = null

// Loads the viewer script once per page.
export const load = () => {
  script = script || addScript(AUTOPILOT_VIEWER, false)
  return script
}

// A new viewer in `element`. viewer.load(url) resolves once the model is on screen;
// viewer.dispose() frees it, also mid-load (the load then rejects with an AbortError).
export const create = element => AutopilotViewer.create(element, options)
